/* global $ */

export default function () {
  let $elements = document.querySelectorAll('[data-module="checkbox-toggle"]')

  for (let i = 0; i < $elements.length; i++) {
    init($elements[i])
  }
}

function init ($element) {
  const $toggle = $element.querySelector('input[data-checkbox]')
  const $container = $element.querySelector('[data-checkbox-target]')

  $toggle.addEventListener('input', function () {
    update(this.checked)
  })

  function update(value) {
    if (value === true) {
      $container.style.display = ''
      $toggle.setAttribute('aria-expanded', 'true')
    } else {
      $container.style.display = 'none'
      $toggle.setAttribute('aria-expanded', 'false')

      // TODO remove hard-coded values, get from DOM
      const attributes = {
        'is-gift': '',
        'gift-from': '',
        'gift-to': '',
        'gift-message': '',
        'gift-special-requests': ''
      }
      Array.from($container.querySelectorAll('input, textarea'))
        .forEach(x => { x.value = '' })

      // https://raw.githubusercontent.com/carolineschnapp/carolineschnapp-gift-wrap/master/gift-wrapping.liquid
      $.ajax({
        type: 'POST',
        url: '/cart/update.js', 
        data: { attributes }, 
        dataType: 'json'
        // Trust it
        // success: function() { location.href = '/cart'; }
      })
    }
  }
}
